export default __webpack_public_path__ + "static/media/Vikas-Surera.1b20f135.pdf";